module.exports = __webpack_public_path__ + "static/img_1.d2074b86.png";